import { Injectable } from '@angular/core';
import {SharedModule} from '../shared.module';
import {FormGroup} from '@angular/forms';

@Injectable({
  providedIn: SharedModule
})
export class EnableDisableFormgroupService {

  constructor() { }

  disableFormElements(form: FormGroup, path: string[], elements: string []): void {
    Object.keys(form.get(path)['controls']).forEach(key => {
      if (elements.indexOf(key) > -1) {
        path.push(key);
        form.get(path).disable({ emitEvent: false } );
        path.pop();
      }
    });
  }
  enableFormElements(form: FormGroup, path: string[], elements: string []): void {
    Object.keys(form.get(path)['controls']).forEach(key => {
      if (elements.indexOf(key) > -1) {
        path.push(key);
        form.get(path).enable({ emitEvent: false } );
        path.pop();
      }
    });
  }
}
